/**
 * This enum is used to display the user preferences
 * for the open project page display count option
 */
export enum OpenProjectDisplayCountOption {
  'FIVE' = 5,
  'TEN' = 10,
  'FIFTEEN' = 15,
  'TWENTY' = 20,
  'TWENTY_FIVE' = 25,
  'ALL' = 'all'
}
